import { Modal } from "react-bootstrap";
import VideoDrmPlayer from "../../features/video_feature/video_feature_content_component/VideoDrmPlayer";

const TestimonialModal = ({ show, onHide, selectedTestimonial }) => {
  if (!selectedTestimonial) return null;

  const { student_name, target, AIR, image, testimonials, video_id } =
    selectedTestimonial;

  return (
    <Modal
      show={show}
      onHide={onHide}
      dialogClassName="testimonial-modal"
      centered
    >
      <Modal.Header closeButton />
      <Modal.Body>
        <div className="modal-student-details">
          <img src={image} alt="student" className="modal-student-img" />
          <div>
            <div className="modal-student-name">{student_name}</div>
            <div className="modal-student-target">
              {target} (AIR {AIR})
            </div>
          </div>
        </div>

        {video_id && (
          <div className="testimony-modal-video">
            <VideoDrmPlayer id_video={video_id} />
          </div>
        )}

        <div className="testimony-modal-feedback-section">
          <h5 className="testimony-modal-feedback-heading">Feedback</h5>
          <p className="testimony-modal-feedback-text">{testimonials}</p>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default TestimonialModal;
